import React from 'react';
import PropTypes from 'prop-types';
import { SwitchContainer, SwitchInput, SwitchLabel, SwitchButton } from './styles';

const Switch = ({ id, onChange, dataPanel, toggled = false, disabled = false, width = 'auto' }) => {
  return (
    <SwitchContainer data-panel={dataPanel.container} width={width}>
      <SwitchInput
        data-panel={`switch-input-${dataPanel}`}
        className='switch-checkbox'
        id={id}
        type='checkbox'
        checked={toggled}
        onChange={onChange}
      />
      <SwitchLabel
        data-panel={`switch-label-${dataPanel}`}
        className='switch-label'
        htmlFor={id}
        toggled={toggled}
        disabled={disabled}
      >
        <SwitchButton className='switch-button' />
      </SwitchLabel>
    </SwitchContainer>
  );
};

Switch.propTypes = {
  id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  onChange: PropTypes.func.isRequired
};

export default Switch;
